import { createSlice } from "@reduxjs/toolkit";

const initialIPList = {
  IPList: "",
};

const initialUsernameAndPassword = {
  username: "",
  password: "",
  newPassword: "",
  newPasswordConfirm: ""
};

const initialUserActionsState = {
  listLoading: false,
  actionsLoading: false,
  userGroups: [],
  filters: [],
  IPList: initialIPList,
  usernameAndPassword: initialUsernameAndPassword
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const userActionSlice = createSlice({
  name: "userActions",
  initialState: initialUserActionsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getUserGroups
    userGroupsFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.userGroups = action.payload.entities;
    },
    // getUsers
    usersFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities =  authorities;
    },
    // getFilters
    filtersFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.filters = action.payload.entities;
    },
    // getIPList
    IPListFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.IPList.IPList = action.payload.entity;
    },
    // getUsername
    usernameFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.usernameAndPassword.username = action.payload.entity;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanIPList
    IPListCleaned: (state) => {
      state.IPList.IPList = "";
    },
    // cleanUsername
    usernameCleaned: (state) => {
      state.usernameAndPassword.username = "";
    },
    // cleanUserActionsState
    userActionsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});